import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[AH] Uncaught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#FAF9F7', fontFamily: '"Cormorant Garamond", Georgia, serif', color: '#1A1A1A',
          padding: '2rem', textAlign: 'center',
        }}>
          <div style={{ maxWidth: 420 }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: 300, letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '1rem' }}>
              Something went wrong
            </h1>
            <p style={{ fontSize: '0.875rem', lineHeight: 1.6, opacity: 0.6, marginBottom: '1.5rem' }}>
              An unexpected error occurred. Please reload the page.
            </p>
            <pre style={{
              fontSize: '0.7rem', textAlign: 'left', background: '#f0efed', padding: '1rem',
              borderRadius: '4px', overflow: 'auto', maxHeight: 160, marginBottom: '1.5rem', opacity: 0.5,
            }}>
              {this.state.error?.message}
            </pre>
            <button
              onClick={() => { localStorage.clear(); window.location.reload(); }}
              style={{
                padding: '0.6rem 1.5rem', fontSize: '0.75rem', letterSpacing: '0.15em',
                textTransform: 'uppercase', border: '1px solid #1A1A1A', background: 'transparent',
                cursor: 'pointer', marginRight: '0.75rem',
              }}
            >
              Reset &amp; Reload
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '0.6rem 1.5rem', fontSize: '0.75rem', letterSpacing: '0.15em',
                textTransform: 'uppercase', border: '1px solid #1A1A1A', background: '#1A1A1A',
                color: '#FAF9F7', cursor: 'pointer',
              }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
